import { css } from "styled-components/macro";
import {
    border,
    defaultRadius,
    distances,
    palette,
} from "../../styles/constants";

export const buttonStylesheet = css`
    padding: 10px 16px;
    border-radius: ${defaultRadius};
    color: white;
    background: ${palette.primary[500]};
    border: ${border.normal} solid ${palette.primary[500]};
    text-decoration: none;
    user-select: none;
    font-weight: 500;
    font-size: 14px;
    line-height: ${distances.small};
    cursor: pointer;
    min-height: 40px;
    display: inline-block;
    text-align: center;
    transition: all 0.15s;

    line-height: 20px;

    outline: 4px solid transparent;

    &:hover {
        background: ${palette.primary[600]};
        border: ${border.normal} solid ${palette.primary[600]};
    }

    &:focus {
        outline-color: ${palette.primary[100]};
        outline-offset: 6px;
    }

    &:disabled {
        background: ${palette.primary[300]};
        border-color: ${palette.primary[300]};
        cursor: not-allowed;
    }

`;
